import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import { useSelector } from "react-redux";
import x_icon from "../../assets/images/courses/x_icon.png";
import Repository from "../../configs/axios/repository";
const jaccardFunc = (text1, text2) => {
    const preprocessText = (text) => {
        if (typeof text !== "string") {
            text = text.toString();
        }
        text = text.toLowerCase(); // Convert text to lowercase
        text = text.replace(/[^\w\s]/g, ""); // Remove punctuation
        return text.split(/\s+/); // Tokenize the text
    };

    const set1 = new Set(preprocessText(text1));
    const set2 = new Set(preprocessText(text2));
    const intersection = [...set1].filter((x) => set2.has(x)).length;
    const union = set1.size + set2.size - intersection;
    const jaccardSimilarity = intersection / union;
    return jaccardSimilarity;
};

const Items = ({ currentItems, items, deleteQuestion, showAnswer }) => {
    const role = useSelector((state) => state.layout.role);
    const queryParameters = new URLSearchParams(window.location.search);
    const result_test_id = queryParameters.get("result_test_id");
    return (
        <>
            {currentItems &&
                currentItems.map((item, i) => {
                    let similarity;
                    let answer;
                    if (
                        item.userAnswer == undefined ||
                        item.userAnswer == null ||
                        item.userAnswer == ""
                    ) {
                        answer = item.answer;
                    } else if (Array.isArray(item.answer)) {
                        similarity = jaccardFunc(
                            item?.answer?.join(", "),
                            item.userAnswer ? item.userAnswer : ""
                        );
                        answer = item.answer.join(", ");
                    } else {
                        similarity = jaccardFunc(
                            item.answer,
                            item.userAnswer ? item.userAnswer : ""
                        );
                        answer = item.answer;
                    }
                    return (
                        <div key={i}>
                            <div className="results">
                                <div>
                                    <div className="questionResult">
                                        {item.question}
                                    </div>
                                    <div className="betweenDiv"></div>
                                    <div className="answerSectionDiv">
                                        <div className="resultAnswer">
                                            <div className="answerResult">
                                                Correct Answer: ({answer})
                                            </div>
                                            {role == "instructor" &&
                                            !result_test_id ? (
                                                ""
                                            ) : (
                                                <div className="answerResult">
                                                    User Answer: (
                                                    {item.userAnswer})
                                                </div>
                                            )}
                                        </div>
                                        {role == "instructor" &&
                                        !result_test_id ? (
                                            <div className="resultImgWritten">
                                                <img
                                                    className="rightImgWritten x_icon"
                                                    src={x_icon}
                                                    alt="x_icon"
                                                    onClick={() => {
                                                        deleteQuestion(item.id);
                                                    }}
                                                />
                                            </div>
                                        ) : (
                                            <div className="jakard">
                                                <span>
                                                    {Math.round(
                                                        similarity * 100
                                                    )}
                                                    %
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
        </>
    );
};

function PaginationAnonymousResultWritten({
    itemsPerPage,
    items,
    deleteQuestion,
    scoreResult,
    test_id,
    firstName,
    lastName,
    guid,
}) {
    let isCreate = true;
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + itemsPerPage;
    const currentItems = items.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(items.length / itemsPerPage);
    
    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % items.length;
        setItemOffset(newOffset);
    };

    const createResult = async () => {
        isCreate = false;
       
        const result = await Repository.postRequest(
            `api/resultTest/createAnonymousResultTest`,
            {
                question_count: items.length,
                score: scoreResult,
                answers: JSON.stringify(items),
                test_id: { test_id: test_id },
                userStatus: "anonymous",
                name: `${firstName + " " + lastName}`,
                email: "",
                one_time_guid: guid,
            }
        );
    };

    useEffect(() => {
        if (isCreate == true) {
            createResult();
        }
    }, []);
    return (
        <>
            <Items
                currentItems={currentItems}
                items={items}
                deleteQuestion={deleteQuestion}
            />
            <div className="paginationContent">
                <ReactPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pageCount}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    containerClassName={"pagination"}
                    previousLinkClassName={"pagination__link"}
                    nextLinkClassName={"pagination__link"}
                    disabledClassName={"pagination__link--disabled"}
                    activeClassName={"pagination__link--active"}
                />
            </div>
        </>
    );
}
export default PaginationAnonymousResultWritten;
